var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseInput = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.264417 0.257271C0.616974 -0.085757 1.18858 -0.085757 1.54114 0.257271L6.5 5.08211L11.4589 0.257271C11.8114 -0.085757 12.383 -0.085757 12.7356 0.257271C13.0881 0.600299 13.0881 1.15646 12.7356 1.49949L7.59617 6.5L12.7356 11.5005C13.0881 11.8435 13.0881 12.3997 12.7356 12.7427C12.383 13.0858 11.8114 13.0858 11.4589 12.7427L6.5 7.91789L1.54114 12.7427C1.18858 13.0858 0.616974 13.0858 0.264417 12.7427C-0.0881391 12.3997 -0.0881391 11.8435 0.264417 11.5005L5.40383 6.5L0.264417 1.49949C-0.0881391 1.15646 -0.0881391 0.600299 0.264417 0.257271Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseInput);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeInput.ae60d64d7c2519749439f0ac78fb9d56.svg";